<div class="card-column-content" [ngClass]="borderClassArray">
  @for (
    card of cardCollection;
    track card;
    let odd = $odd;
    let even = $even;
    let last = $last
  ) {
    @if (!card.isHidden) {
      <div [ngClass]="{ 'column-border-bottom': !last }">
        <app-card
          (cardClick)="cardClicked($event)"
          [enableSelection]="enableSelection ? true : false"
          [ngClass]="{
            'background-color-grey': odd,
            'background-color-white': even
          }"
          [cardModel]="card"
          [isClicked]="card.isClicked"
        ></app-card>
      </div>
    }
  }
</div>
